import Toolbar from '@material-ui/core/Toolbar';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';
// import ReactTooltip from 'react-tooltip';
import { bindActionCreators } from 'redux';
import { changedView, dateChanged, mapLoadingData, setUpdateView } from '../actions';
import LoadingSpinner from '../components/LoadingSpinner/index';
import MapControls from '../containers/MapControls';
import MapIframe from '../containers/MapIframe/index';
import FVMGoogleMaps from '../containers/FVMGoogleMaps';

import { fetchTrackingMapData, fetchHeatMapData } from '../wp-rest-api/STEC-Communication';

const testTracksJson = {
  type: 'FeatureCollection',
  features: [
    {
      'type': 'Feature',
      'geometry': { 'type': 'LineString', 'coordinates': [[7.275579929351807, 47.04079055786133], [7.276609897613525, 47.04182052612305]] },
    },
    {
      'type': 'Feature',
      'geometry': { 'type': 'LineString', 'coordinates': [[7.276579856872559, 47.0418701171875], [7.2765398025512695, 47.0417594909668]] },
    },
    {
      'type': 'Feature',
      'geometry': { 'type': 'LineString', 'coordinates': [[7.276589870452881, 47.04179000854492], [7.275330066680908, 47.040740966796875]] },
    },
    {
      'type': 'Feature',
      'geometry': { 'type': 'LineString', 'coordinates': [[7.275310039520264, 47.040740966796875], [7.276659965515137, 47.04164123535156]] },
    },
    {
      'type': 'Feature',
      'geometry': { 'type': 'LineString', 'coordinates': [[7.276519775390625, 47.04161071777344], [7.276569843292236, 47.04161834716797]] },
    },
    {
      'type': 'Feature',
      'geometry': { 'type': 'LineString', 'coordinates': [[7.276470184326172, 47.04119110107422], [7.276669979095459, 47.04154968261719]] },
    },
    {
      'type': 'Feature',
      'geometry': { 'type': 'LineString', 'coordinates': [[7.276440143585205, 47.04222869873047], [7.277180194854736, 47.04264831542969]] },
    },
    {
      'type': 'Feature',
      'geometry': { 'type': 'LineString', 'coordinates': [[7.2771501541137695, 47.04261016845703], [7.275680065155029, 47.041351318359375]] },
    },
    {
      'type': 'Feature',
      'geometry': { 'type': 'LineString', 'coordinates': [[7.276100158691406, 47.039180755615234], [7.276040077209473, 47.038909912109375]] },
    },
    {
      'type': 'Feature',
      'geometry': { 'type': 'LineString', 'coordinates': [[7.275420188903809, 47.04079818725586], [7.275440216064453, 47.04084014892578]] },
    },
    {
      'type': 'Feature',
      'geometry': {
        'type': 'LineString',
        'coordinates': [[7.27564001083374, 47.04098129272461], [7.288060188293457, 47.05231857299805], [7.289790153503418, 47.05546951293945], [7.293960094451904, 47.05915832519531], [7.294909954071045, 47.061180114746094], [7.297299861907959, 47.077659606933594], [7.29803991317749, 47.07884979248047], [7.30019998550415, 47.07992935180664], [7.3040900230407715, 47.07963180541992], [7.307429790496826, 47.0749397277832]],
      },
    },
    {
      'type': 'Feature',
      'geometry': { 'type': 'LineString', 'coordinates': [[7.307439804077148, 47.07476043701172], [7.306529998779297, 47.076778411865234]] },
    },
    {
      'type': 'Feature', 'geometry': {
        'type': 'LineString',
        'coordinates': [[7.306489944458008, 47.07680130004883], [7.3048200607299805, 47.079471588134766], [7.304780006408691, 47.081871032714844], [7.313149929046631, 47.090091705322266], [7.318329811096191, 47.098751068115234], [7.318600177764893, 47.101131439208984], [7.3160400390625, 47.103599548339844], [7.303929805755615, 47.10847854614258], [7.295929908752441, 47.116119384765625], [7.284939765930176, 47.119049072265625], [7.277530193328857, 47.123680114746094], [7.264570236206055, 47.12382125854492], [7.261270046234131, 47.12546157836914], [7.2564802169799805, 47.12974166870117], [7.249670028686523, 47.130149841308594], [7.233119964599609, 47.13508987426758], [7.230929851531982, 47.13507843017578], [7.207190036773682, 47.121620178222656]],
      },
    },
    {
      'type': 'Feature', 'geometry': {
        'type': 'LineString',
        'coordinates': [[7.206369876861572, 47.120540618896484], [7.193429946899414, 47.112728118896484], [7.183810234069824, 47.108741760253906], [7.175739765167236, 47.101619720458984], [7.17218017578125, 47.09960174560547], [7.165359973907471, 47.09642028808594], [7.1496901512146, 47.090999603271484], [7.1353302001953125, 47.08380126953125], [7.1155500411987305, 47.075740814208984], [7.113659858703613, 47.07400131225586], [7.111700057983398, 47.070438385009766], [7.107150077819824, 47.066951751708984], [7.091760158538818, 47.06153869628906], [7.08512020111084, 47.06119155883789], [7.07873010635376, 47.059078216552734], [7.066619873046875, 47.05677032470703], [7.054900169372559, 47.05672073364258], [7.042409896850586, 47.053348541259766], [7.025929927825928, 47.0418586730957], [7.022359848022461, 47.03733825683594], [7.011519908905029, 47.03289031982422], [7.002170085906982, 47.023651123046875], [6.992599964141846, 47.017948150634766], [6.9870100021362305, 47.01570129394531], [6.979010105133057, 47.013858795166016], [6.966629981994629, 47.00912094116211], [6.9534101486206055, 47.00278091430664], [6.917769908905029, 46.99127960205078], [6.913479804992676, 46.987571716308594], [6.901509761810303, 46.98305892944336], [6.885039806365967, 46.97980880737305], [6.8775200843811035, 46.979679107666016], [6.868390083312988, 46.97808837890625], [6.866049766540527, 46.976951599121094], [6.863170146942139, 46.97406005859375], [6.855500221252441, 46.97003936767578], [6.84984016418457, 46.96842956542969], [6.844150066375732, 46.963680267333984], [6.826409816741943, 46.95684051513672], [6.823470115661621, 46.95381164550781], [6.820380210876465, 46.943599700927734], [6.803150177001953, 46.9168815612793], [6.789120197296143, 46.90425109863281], [6.776249885559082, 46.89630889892578], [6.757349967956543, 46.87726974487305], [6.752089977264404, 46.86817169189453], [6.738840103149414, 46.85811996459961], [6.717700004577637, 46.84825897216797], [6.711160182952881, 46.84457015991211], [6.703320026397705, 46.83877944946289], [6.684279918670654, 46.829898834228516], [6.675759792327881, 46.82271957397461], [6.671130180358887, 46.820560455322266], [6.661509990692139, 46.81803894042969], [6.643519878387451, 46.80690002441406], [6.634160041809082, 46.80316925048828], [6.631209850311279, 46.801029205322266], [6.6288299560546875, 46.795989990234375], [6.629549980163574, 46.792598724365234], [6.635119915008545, 46.784278869628906], [6.638239860534668, 46.782508850097656], [6.642749786376953, 46.781368255615234]],
      },
    }, {
      'type': 'Feature', 'geometry': {
        'type': 'LineString',
        'coordinates': [[6.644120216369629, 46.780879974365234], [6.652850151062012, 46.77899169921875], [6.658209800720215, 46.779998779296875], [6.666190147399902, 46.78464126586914], [6.673620223999023, 46.78773880004883], [6.68625020980835, 46.79161071777344], [6.695300102233887, 46.7959098815918], [6.702980041503906, 46.79851150512695], [6.725930213928223, 46.801979064941406], [6.73429012298584, 46.80242919921875], [6.739290237426758, 46.802310943603516], [6.755589962005615, 46.799400329589844], [6.75875997543335, 46.799591064453125], [6.79557991027832, 46.822731018066406], [6.799429893493652, 46.82640838623047], [6.813029766082764, 46.836341857910156], [6.829750061035156, 46.84162902832031], [6.837530136108398, 46.842838287353516], [6.847809791564941, 46.845821380615234], [6.8514299392700195, 46.845340728759766], [6.857100009918213, 46.83982849121094], [6.867080211639404, 46.83591842651367], [6.8730998039245605, 46.832088470458984], [6.874390125274658, 46.8294792175293], [6.873449802398682, 46.82509994506836], [6.873960018157959, 46.82194137573242], [6.877620220184326, 46.817569732666016], [6.8809099197387695, 46.8159294128418], [6.895959854125977, 46.81612014770508], [6.906819820404053, 46.81975173950195], [6.9168701171875, 46.82040023803711], [6.928679943084717, 46.817138671875], [6.934370040893555, 46.81645965576172], [6.9369401931762695, 46.81718063354492], [6.941760063171387, 46.82112121582031]],
      },
    },
    {
      'type': 'Feature', 'geometry': {
        'type': 'LineString',
        'coordinates': [[6.94182014465332, 46.8211784362793], [6.949090003967285, 46.82796096801758], [6.96205997467041, 46.836700439453125], [6.968239784240723, 46.844139099121094], [6.995339870452881, 46.860530853271484], [7.013420104980469, 46.86975860595703], [7.0219597816467285, 46.875938415527344], [7.031620025634766, 46.8785400390625], [7.04371976852417, 46.886478424072266], [7.071249961853027, 46.90700912475586], [7.087540149688721, 46.91286087036133], [7.091780185699463, 46.91606140136719], [7.1061601638793945, 46.923221588134766], [7.1112799644470215, 46.92367172241211], [7.122260093688965, 46.92742156982422], [7.125770092010498, 46.93022155761719], [7.128300189971924, 46.93442916870117], [7.134270191192627, 46.93927001953125], [7.142350196838379, 46.94342041015625], [7.160699844360352, 46.95668029785156], [7.181829929351807, 46.96514129638672], [7.191699981689453, 46.972869873046875], [7.202300071716309, 46.99551010131836], [7.223840236663818, 47.017738342285156], [7.233630180358887, 47.024818420410156], [7.259990215301514, 47.03987121582031], [7.262979984283447, 47.04045867919922], [7.26908016204834, 47.03989028930664], [7.27603006362915, 47.04180145263672], [7.278250217437744, 47.04391098022461], [7.2764201164245605, 47.04195022583008]],
      },
      'properties': {
        'lineType': 'dashed',
        'dashTracksColor': 'red',
      },
    }],
};

const getHeatMapData = async (vehicleId, period) => {
  const { endDate, startDate } = period;
  const heatMapData = {
    vehicleId,
    period,
    track: [],
    type: 'FeatureCollection',
  };
  const reqData = await  fetchHeatMapData( { endDate, startDate, vehicleId } );

  return { ...heatMapData, ...reqData };
};


const getTrackingMapData = async (vehicleId = 213, period) => {
  const { endDate, startDate } = period;
  const trackingData = {
    vehicleId,
    period,
    type: 'FeatureCollection',
    features: [],
    //...testTracksJson // for testing purposes
  };
  const reqData = await fetchTrackingMapData( { endDate, startDate, vehicleId } );
  return { ...trackingData, ...reqData };
};

/**
 *
 */
class TrackingMap extends Component {
  constructor(props) {
    super(props);

    let { period, activeUserLocoId } = this.props;
    if ((period.startDate && period.endDate) && !!period.endDate.diff(period.startDate, 'month')) {
      period.startDate = moment(period.endDate).subtract(1, 'month');
      props.onDateChange(period);
      // props.onDateChange({
      //   startDate: moment().locale('en-gb').startOf('day').subtract(3, 'days'),
      //   // startDate: moment().locale('en-gb').startOf('day').subtract(11, 'months'),
      //   endDate: moment().locale('en-gb').startOf('day').subtract(1, 'days'),
      // });
    }

    this.state = {
      open: false,
      activeUserLocoId: activeUserLocoId,
      period: period,
      trackingMapData: {
        vehicleId: 0,
        track: [],
        period: period,
        type: 'FeatureCollection',
        features: [],
      },
      heatMapData: {
        vehicleId: 0,
        track: [],
        period: period,
        type: 'FeatureCollection',
        features: [],
      },
    };

    this.handleDrawerOpen = this.handleDrawerOpen.bind(this);
    this.handleDrawerClose = this.handleDrawerClose.bind(this);
    this.handleClearAll = this.handleClearAll.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.getTrackingMapTracks = this.getTrackingMapTracks.bind(this);
    this.getHeatMapTracks = this.getHeatMapTracks.bind(this);
  }

  componentDidMount() {
    this.props.setUpdateView(false);
    const { period, activeUserLocoId } = this.state;
    if (period && this.props.activeUserLocoId) {
      this.getTrackingMapTracks(activeUserLocoId, period);
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { period, activeUserLocoId } = this.props;

    if (period) {
      if (period.startDate.format('YYYYMMDD') !== prevProps.period.startDate.format('YYYYMMDD') ||
        period.endDate.format('YYYYMMDD') !== prevProps.period.endDate.format('YYYYMMDD') ||
        prevProps.activeUserLocoId !== activeUserLocoId) {
        this.getTrackingMapTracks(activeUserLocoId, period);
      }
    }
  }

  handleDrawerOpen() {
    this.setState({ open: !this.state.open });
  }

  handleDrawerClose() {
    this.setState({ open: false });
  }

  handleClearAll() {
    const { selected } = this.state;
    Object.keys(selected).forEach((item) => {
      selected[item] = false;
    });
  }

  handleChange(selectedCheckbox) {
    const { selected } = this.state;
    selected[selectedCheckbox] = !selected[selectedCheckbox];
    const secondLevel = Object.values(selected).includes(true);
    this.setState({ selected, secondLevel });
  }


  async getTrackingMapTracks(activeUserLocoId, period) {
    let trackingMapData = {
      vehicleId: 0,
      track: [],
      period,
      type: 'FeatureCollection',
      features: [],
    };
    let heatMapData = {
      vehicleId: 0,
      track: [],
      period,
      type: 'FeatureCollection',
      features: [],
    };

    if (activeUserLocoId) {
      this.props.showLoading(true);
      const heatMapDataResp = await getHeatMapData(activeUserLocoId, period);
      const trackingMapDataResp = await getTrackingMapData(activeUserLocoId, period);

      if ((heatMapDataResp.vehicleId === this.props.activeUserLocoId) && this.props.activeUserLocoId) {
        heatMapData = { ...heatMapDataResp };
      }

      if ((trackingMapDataResp.vehicleId === this.props.activeUserLocoId) && this.props.activeUserLocoId) {
        trackingMapData = { ...trackingMapDataResp };

      }
    } else {
      this.testGeoJsonHeatmap = heatMapData;
      this.testGeoJsonTracking = trackingMapData;
    }



    this.testGeoJsonHeatmap = { ...heatMapData };
    this.testGeoJsonTracking = { ...trackingMapData };

    this.setState({ trackingMapData, heatMapData });
    this.props.showLoading(false);
  }

  async getHeatMapTracks(activeUserLocoId, period) {
    let heatMapData = {
      vehicleId: 0,
      track: [],
      period,
      type: 'FeatureCollection',
      features: [],
    };
    if (activeUserLocoId) {
      heatMapData = await getHeatMapData(activeUserLocoId, period);
    }

    this.setState({ heatMapData });
  }


  render() {
    const { t, isRailationDrawOpen, activeUserLocoId } = this.props;
    const isCrane = !!activeUserLocoId && this.props.userLocomotiveListObject[activeUserLocoId].isCrane;
    const { trackingMapData, heatMapData } = this.state;

    return (
      <article className="fvm-page fvm-page-tracking">
        <div className="fvm-map-page-toolbar-container">
          <Toolbar
            className="fvm-map-page-toolbar"
            disableGutters
          >
            {this.props.t ? <MapControls t={this.props.t} isTrackingDisabled={isCrane}/> : null}
          </Toolbar>
        </div>
        <div className="fvm-general-page-content">
          <section className="fvm-sp fvm-sp-map-iframe no-gutters container-fluid mb-0">
            <div className="row">
              <div className="col fvm-map-iframe">
                {
                  // Object.keys(this.props.userLocomotiveListObject).length > 0
                  //   ? (
                      <FVMGoogleMaps
                        t={t}
                        railationFeatures={[]}
                        trackingMapData={trackingMapData}
                        heatMapData={heatMapData}
                      />

                      // localStorage.getItem('fvmfeatureactive')
                      //   ? <FVMGoogleMaps
                      //     t={t}
                      //     railationFeatures={[]}
                      //     trackingMapData={trackingMapData}
                      //     heatMapData={heatMapData}
                      //   />
                      //   : <MapIframe currentView="trackingmap" open={isRailationDrawOpen} t={t}/>
                    // )
                    // : null
                }
              </div>
            </div>
          </section>
        </div>
        {this.props.isShowLoading ? <LoadingSpinner/> : null}
        {/*<ReactTooltip className="fvm-tooltip" />*/}
      </article>
    );
  }
}

TrackingMap.propTypes = {
  newView: PropTypes.func.isRequired,
  isShowLoading: PropTypes.bool.isRequired,
  userLocomotiveListObject: PropTypes.objectOf(PropTypes.object).isRequired,
};
const mapStateToProps = state => ({
  isShowLoading: state.isMapLoading,
  activeUserLocoId: [...state.activeUserLocomotiveListIds].pop() || 0,
  isDevelopment: state.isDevelopment,
  isRailationDrawOpen: state.railationDrawOpen,
  userLocomotiveListObject: state.userLocomotiveList,
  period: state.period,
});

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    onDateChange: dateChanged,
    newView: changedView,
    showLoading: mapLoadingData,
    setUpdateView,

  }, dispatch)
);
export default connect(mapStateToProps, mapDispatchToProps)(TrackingMap);
